import { Code, Cpu, Users, Sparkles, TrendingUp, Clock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import StructuredData from "./StructuredData";

const Nosotros = () => {
  <StructuredData type="nosotros" />;
  const { language, translations } = useLanguage();
  const nosotros = translations[language].nosotros;
  const stats = [
    {
      value: nosotros.estadisticas[0].value,
      label: nosotros.estadisticas[0].label,
      icon: <TrendingUp size={20} />,
    },
    {
      value: nosotros.estadisticas[1].value,
      label: nosotros.estadisticas[1].label,
      icon: <Clock size={20} />,
    },
  ];

  const values = [
    {
      icon: <Cpu size={30} />,
      title: nosotros.valores[0].title,
      description: nosotros.valores[0].description,
    },
    {
      icon: <Users size={30} />,
      title: nosotros.valores[1].title,
      description: nosotros.valores[1].description,
    },
    {
      icon: <Code size={30} />,
      title: nosotros.valores[2].title,
      description: nosotros.valores[2].description,
    },
    {
      icon: <Sparkles size={30} />,
      title: nosotros.valores[3].title,
      description: nosotros.valores[3].description,
    },
  ];

  return (
    <section id="nosotros" className="py-20 bg-gray-50 dark:bg-[#343b4b]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
            {nosotros.titulos.sobreNosotros}
          </h2>
          <div className="w-24 h-1 bg-[#12A9B0] mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-600 dark:text-gray-400">
              {nosotros.titulos.innovacionMetodoHeuristico}
            </h3>

            <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-400">
              {nosotros.textos.descripcion1}
            </p>

            <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-400">
              {nosotros.textos.descripcion2}
            </p>

            <div className="grid grid-cols-2 gap-6 pt-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="group cursor-pointer transition-all duration-300 hover:transform hover:scale-105 hover:bg-white dark:hover:bg-gray-700/50 p-4 rounded-lg"
                >
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[#12A9B0]">{stat.icon}</span>
                    <div className="text-3xl font-bold text-[#12A9B0]">
                      {stat.value}
                    </div>
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {values.map((value, index) => (
              <div
                key={index}
                className="p-6 rounded-xl text-center transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-xl group bg-white dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900"
              >
                <div className="text-[#12A9B0] mx-auto mb-3 transition-transform duration-300 group-hover:scale-110">
                  {value.icon}
                </div>
                <h4 className="font-semibold mb-2 text-gray-900 dark:text-white">
                  {value.title}
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-500">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 p-8 rounded-2xl text-center bg-gradient-to-r from-[#12A9B0]/5 to-purple-50 dark:bg-gradient-to-r dark:from-gray-800 dark:to-gray-900">
          <blockquote className="text-xl italic">
            <span className="text-[#12A9B0] text-4xl">"</span>
            <span className="text-gray-700 dark:text-gray-300">
              {nosotros.textos.cita}
            </span>
            <span className="text-[#12A9B0] text-4xl">"</span>
          </blockquote>
          <p className="mt-4 font-semibold text-gray-600 dark:text-gray-400">
            {nosotros.textos.firma}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
